import angular from 'angular';
import SideBannersComponent from './side-banners.component';

let SideBannersModule = angular.module('shared.components.banners.sideBanners', [])
  .component('sideBanners', SideBannersComponent);

export default SideBannersModule;



/** WEBPACK FOOTER **
 ** C:/xampp/htdocs/payomaro-pay-zone/www/components/shared/components/banners/side-banners/side-banners.js
 **/